(() => {
  'use strict';
  const normalize = value => String(value).normalize('NFD').replace(/\p{M}/gu,'').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu,' ').trim();
  const stems={ro:{sticla:'sticl',sticle:'sticl',cana:'can',cani:'can',tricouri:'tricou',pixuri:'pix'},pl:{butelka:'butelk',butelki:'butelk'},it:{bottiglia:'bottigli',bottiglie:'bottigli'}};
  const termsFor = (query, locale) => normalize(query).split(' ').filter(Boolean).map(t => stems[locale]?.[t] || t);
  function search(rows, query, locale) {
    const terms=termsFor(query,locale);
    if (!terms.length || terms.length>20 || query.length>200) return [];
    return rows.map(row=>{
      const words=row.x.split(' ');
      if (!terms.every(term=>words.some(word=>word.startsWith(term)))) return null;
      const title=normalize(row.t),category=normalize(row.c);
      const score=terms.reduce((sum,term)=>sum+(title.includes(term)?10:0)+(category.includes(term)?20:0),0)+(title===normalize(query)?100:0);
      return {row,score};
    }).filter(Boolean).sort((a,b)=>b.score-a.score||a.row.t.localeCompare(b.row.t,locale));
  }
  globalThis.LaserBroCatalogSearchCore=Object.freeze({normalize,termsFor,search});
})();
